import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { PortalVisitResponse } from "../models/portal-visit.model";

@Injectable({
  providedIn: "root",
})
export class VisitorPortalService {
  private readonly http = inject(HttpClient);

  getVisitByPortalUuid(portalUuid: string): Observable<PortalVisitResponse> {
    return this.http.get<PortalVisitResponse>(`/v1/visitors/portal/${portalUuid}`);
  }
}
